import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faUser } from "@fortawesome/free-solid-svg-icons";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import UserService from "../../../services/UserService";
import { ROUTES } from "../../../config/routes";

export default function NavTabs() {
  const { user, isAuthenticated, logout, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const [profileFirstName, setProfileFirstName] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadUser = async () => {
      try {
        if (!isAuthenticated) return;
        const token = await getAccessTokenSilently();
        const data = await UserService.user(token);
        if (isMounted) {
          setProfileFirstName(
            data?.firstName || data?.givenName || data?.given_name || user?.given_name || null
          );
        }
      } catch (e) {
        if (isMounted) {
          setProfileFirstName(user?.given_name || null);
        }
      }
    };
    loadUser();
    return () => { isMounted = false; };
  }, [isAuthenticated, getAccessTokenSilently, user]);

  const logoutWithRedirect = () =>
    logout({
      logoutParams: { returnTo: window.location.origin },
    });

  return (
    <div className="fl-tabs">
      <div className="fl-tabs__inner">
        {/* Left area intentionally empty to match screenshot (logo/brand lives elsewhere) */}
        <div className="fl-tabs__left" />

        {/* Right utilities: Hello | Log Out | FAQ | [user] | [cog] */}
        <div className="fl-tabs__right">
                {isAuthenticated && (
                    <span className="fl-hello" style={{ fontWeight: 300 }}>Hello {profileFirstName || user?.given_name || user?.name}</span>
                )}
                      <span className="fl-sep" aria-hidden>|</span>
            <a 
              href="#" 
              className="fl-link" 
              onClick={(e) => {
                e.preventDefault();
                logoutWithRedirect();
              }}
              style={{ textDecoration: 'none', fontWeight: 300 }}
            >
              Log Out
            </a>
            <a 
              href="https://farelanes.com/frequently-asked-questions/" 
              className="fl-link" 
              rel="noreferrer" 
              target="_blank" 
              style={{ textDecoration: 'none', fontWeight: 300 }}
            >
              FAQ
            </a>
                      <span 
              className="fl-icon" 
              aria-hidden="true"
              onClick={() => {
                // Navigate to Profile tab using route-based navigation
                // For now, use query params for backward compatibility until Dashboard is refactored
                navigate(`${ROUTES.DASHBOARD}?tab=setup&subtab=profile`);
              }}
              style={{ cursor: 'pointer' }}
              title="Profile"
            >
              <FontAwesomeIcon icon={faUser} style={{ fontSize: '16px', opacity: 0.7, filter: 'contrast(0.8)' }} />
            </span>
            <span 
              className="fl-icon" 
              aria-hidden="true"
              onClick={() => {
                // Navigate to Tickers & City Pairs tab using route-based navigation
                // For now, use query params for backward compatibility until Dashboard is refactored
                navigate(`${ROUTES.DASHBOARD}?tab=setup&subtab=tickers`);
              }}
              style={{ cursor: 'pointer' }}
              title="Tickers & City Pairs"
            >
              <FontAwesomeIcon icon={faCog} style={{ fontSize: '16px', opacity: 0.7, filter: 'contrast(0.8)' }} />
            </span>
        </div>
      </div>
    </div>
  );
}
